// extracted by mini-css-extract-plugin
export default {"root":"CollectionControlBar_root__sHpfP","searchInput":"CollectionControlBar_searchInput__NW3VG"};